var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-section"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('div', {
    staticClass: "mb-20px mb-lg-40px"
  }, [_c('h2', {
    staticClass: "tit tit--sm line-height-15 text-center font-weight-regular break-keep"
  }, [_vm.lang === 'ko' ? [_vm._v(" 세이지(SAGE)는 "), _c('br', {
    staticClass: "d-lg-none"
  }), _c('strong', [_vm._v("‘지혜롭고 신뢰할 수 있는 동반자’")]), _vm._v("라는 의미로, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _c('span', {
    staticClass: "mt-lg-2"
  }, [_vm._v("변화와 도전을 맞이하여 깊은 통찰과 전문성을 바탕으로 고객의 권익을 지키겠다는 저희의 다짐을 담고 있습니다.")])] : [_vm._v(" SAGE stands for "), _c('br', {
    staticClass: "d-lg-none"
  }), _c('strong', [_vm._v("“a wise and trustworthy companion,”")]), _vm._v(" "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" embodying our unwavering commitment to safeguarding our clients' interests "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" with deep insight and professionalism amid constant change and evolving challenges. ")]], 2)]), _c('v-card', {
    staticClass: "border-t border-b text-center mx-auto pa-3 pa-lg-6",
    attrs: {
      "flat": "",
      "tile": "",
      "width": "fit-content"
    }
  }, [_c('p', {
    staticClass: "txt txt--dark break-keep"
  }, [_vm.lang === 'ko' ? [_vm._v("세이지는 M&A를 포함한 기업자문 분야와 국내 소송 중심의 분쟁해결 분야에서, 국내외 고객들로부터 높은 신뢰와 평가를 받고 있음을 자부합니다.")] : [_vm._v(" SAGE is proud to be recognized and trusted by both domestic and international clients for its expertise in corporate advisory services, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" including M&A, as well as dispute resolution with a focus on domestic litigation. ")]], 2)]), _c('div', {
    staticClass: "btn-wrap btn-wrap--xl text-center"
  }, [_c('v-btn', {
    staticClass: "min-w-120px min-w-lg-160px",
    attrs: {
      "x-large": "",
      "outlined": "",
      "color": "grey-darken4",
      "to": _vm.lang === 'ko' ? '/firm' : '/en/firm'
    }
  }, [_vm.lang === 'ko' ? [_vm._v("더보기")] : [_vm._v("Read More")]], 2)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }